import { render, staticRenderFns } from "./youtubeVideo.vue?vue&type=template&id=087084b4&"
import script from "./youtubeVideo.vue?vue&type=script&lang=js&"
export * from "./youtubeVideo.vue?vue&type=script&lang=js&"
import style0 from "./youtubeVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Jenkins\\jobs\\SlideShow\\branches\\release-07-00-09.6uaoor\\workspace\\Scripts\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('087084b4')) {
      api.createRecord('087084b4', component.options)
    } else {
      api.reload('087084b4', component.options)
    }
    module.hot.accept("./youtubeVideo.vue?vue&type=template&id=087084b4&", function () {
      api.rerender('087084b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "youtubeVideo.vue"
export default component.exports